
import {
    Directive,
    ElementRef,
    Renderer,
    EventEmitter,
    Output, Input, Injectable
} from '@angular/core';
import { GeneralService } from '../class/general.service';

@Directive({
    selector: '[number]',
})
@Injectable()
export class MoneyDirective {


    @Input("percent") percent: boolean = false;
    constructor(private element: ElementRef, private renderer: Renderer,public generalService: GeneralService) { }
    ngOnInit() {

        this.element.nativeElement.addEventListener("keyup", (event) => {
            if (this.percent) {
                this.generalService.ValidatePercent(event);
            } else {
                this.generalService.ValidateMoney(event);
            }
        });
        this.element.nativeElement.addEventListener(
            'click',
            (event) => {
              
                    if (event.target.value === "0") {
                        event.target.value = "";
                    }
                
            }, false);

            this.element.nativeElement.onblur = (e) => {
              
                if (e.target.value === "") {
                    e.target.value = 0;
                }

            };

    }
    ValidatePercent(event: any) {
        if (!event.target.value) {
            event.target.value = "";
        }
        if (event.target.value > 100) {
            event.target.value = 100;
        }
    }
    ValidateMoney(event: any) {
        if (!event.target.value) {
            event.target.value = "";
        }
        if (event.target.value < 0) {
            event.target.value = 0;
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/components/directives/number.directive.ts